import styled from 'styled-components';
import { doodles } from '../../styles/decor';

export const Fake = styled.div`
    background-color:#DDD;
    height:${props=>props.height || 20}px;
`;

export const SearchArea = styled.div`
background-color:#FFF;
padding:60px 0 20px;

    
    .WindowArea {
        position:fixed;
        left:0;
        top:0;
        bottom:0;
        right:0;
        background-color:transparent;
        display:none;
        transition:opacity ease 5s;
        justify-content: center;
        align-items: center;
        overflow-y:auto;

        .WindowBody {
            width:900px;
            opacity:0;
            background-color:#FFF;
            border-radius:10px;
            box-shadow:0px 0px 15px #999;
            display:flex;
            margin:20px 0px;
            transition:all ease .5s;
        }
        .ProdutoBig{
            flex:1;
            display:flex;
            justify-content: center;
            align-items: center;
        }
    
        .ProdutoBig img {
            height:250px;
            width:auto;
            border-radius:5px;
            box-shadow:1px 1px 5px #CCC;
        }
        .ProdutoInfo {
            flex:1;
            font-family:'Hepta Slab', Helvetica, Arial;
            padding-bottom:50px;
        }
        .ProdutoInfo h2 {
            margin-top:50px;
        }
        .ProdutoInfo .ProdutoInfo--desc {
            font-size:15px;
            color: #999;
            margin-top:10px;
            font-family:'Lato',Helvetica,Arial;
        }
        .ProdutoInfo--sector {
            color: #CCC;
            text-transform: uppercase;
            font-size:14px;
            margin-top:30px;
            margin-bottom:10px;
        }
        
        .ProdutoInfo--price {
            display:flex;
            align-items:center;  
        }
       
        .ProdutoInfo--actualPrice {
            font-size:28px;
            margin-right:30px;
        }
        .ProdutoInfo--qtarea {
            display:inline-flex;
            background-color:#EEE;
            border-radius:10px;
            height:30px;
        }
        .ProdutoInfo--qtarea button {
            border:0;
            background-color:transparent;
            font-size:17px;
            outline:0;
            cursor:pointer;
            padding:0px 10px;
            color:#333;
        }
        .ProdutoInfo--qt {
            line-height: 30px;
            font-size: 12px;
            font-weight: bold;
            padding: 0px 5px;
            color:#000;
        }
        .ProdutoInfo--addButton {
            margin-top:30px;
            padding:20px 30px;
            border-radius:20px;
            background-color: #48d05f;
            color:#FFF;
            display:inline-block;
            cursor:pointer;
            margin-right:30px;
        }
        .ProdutoInfo--addButton:hover {
            background-color:#32a345;
        }
        .ProdutoInfo--cancelButton {
            display:inline-block;
            cursor:pointer;
        }
        .ProdutoInfo--cancelMobileButton {
            display:none;
            height:40px;
            text-align:center;
            line-height: 40px;
            margin-bottom:30px;
        }
    }

    .LocalizacaoArea{
        flex-direction:column;
        padding:0px;
        border-radius:5px;
        box-shadow:1px 1px 1px 0.3px rbga(0,0,0,0.2);
        display:flex;
        flex-wrap:wrap;
        cursor:pointer;

        h2{
            color:tomato;
            padding:0px 10px;
            margin:0px;
            font-size:20px;
        }

        .Grupo{
            display:flex;
            flex-direction:row;
            justify-content:space-between;
            flex-wrap:wrap;

            .ItemGrupo{
                display:flex;
                flex-direction:column;
                justify-content:center;
                align-items:center;
                background-color:#FFF;
                width:150px;
                height:150px;
                border-radius:75px;
                transition:all ease .5s;
                img{
                    height:70px;
                }
    
                .ItemTitulo{
                    color:tomato;
                }
            }
    
            .ItemGrupo--ativo{
                border:1px solid #FF0000;
            }
    
            .ItemGrupo--inativo{
                border:1px solid #CCC;
            }
        }
    }

@media (max-width:800px){
    .LocalizacaoArea{
        height:auto;

        .Grupo{
           
            .ItemGrupo{
                margin:10px 20px;
            }
        }
    }  
}
@media (max-width:600px){

    .WindowArea{

        .WindowBody{
            flex-direction:column;
            width:100%;
            height:100%;
            padding:20px;
            justify-content:center;
            align-items:center;
        }
        
    }
    .LocalizacaoArea{
        height:auto;

        .Grupo{
           
            .ItemGrupo{
                margin:10px 10px;
            }
        }
    }
}
`;

export const PageArea = styled.div`
display:flex;
background-color:transparent;
padding-top: 0;
position:relative;
isolation:isolate;

&::before{
    content:'';
    position:absolute;
    top:0;
    left:50%;
    width:100vw;
    height:620px;
    transform:translateX(-50%);
    background:${doodles('#ec1c24', .08)} 0 0 / 220px;
    -webkit-mask-image:linear-gradient(180deg, #000 0%, #000 50%, transparent 100%);
    mask-image:linear-gradient(180deg, #000 0%, #000 50%, transparent 100%);
    z-index:-1;
    pointer-events:none;
}
h2 {
    margin:10px;
    font-family:'Inter','bariol-regular-webfont','Open Sans',sans-serif;
    font-size:clamp(34px, 4.4vw, 58px);
    line-height:1.08;
    letter-spacing:-0.03em;
    color:#171717;
    font-weight:700;
}

aside {
    width:0%;
    height:0;
    font-family:'Hepta Slab', Helvetica, Arial;
    transition:all ease .2s;
    overflow-x:hidden;
    border:1px solid #FFFFFF;   
    background-color:#ffffff;

    .cart--area {
        padding:20px;
        
        .cart--cep{
            display:flex;
            margin:10px 0px;

            .cart--loadingCEP{
                display:flex;
                justify-content:center;
                align-items:flex-start;
                width:40px;
                height:25px;
                padding-top:5px;

            }
            
            .cart--cepInfo{
                
                input{
                    border:1px solid #CCC;
                    border-radius:5px;
                    height:25px;
                    width:105px;
                    outline:0;
                    padding:5px;
                }
            }
            .cart--check{
                display:flex;
                justify-content:center;
                align-items:center;
                margin-left:10px;

                img{
                    height:15px;
                    width:15px;
                }
            }
            
        }

        .cart--end{
            color:#79b9dd;
            font-size:12px;
        }
        .menu-closer1{
            cursor:pointer;
            display:flex;
        }

        .menu-closer2{
            cursor:pointer;
            display:none;
            height:30px;
            width:140px;
            background-color:#48d05f;
            border:1px solid #00FF00;
            border-radius:8px;
            font-size:12px;
            font-weight:bold;
            color:#FFF;
            justify-content:center;
            align-items:center;
        }

        .cart {
            margin-bottom:20px;

            .cart--itens{
                border-bottom:1px solid #CCC;
                
                .cart--products{
                    display:flex;
                    justify-content:flex-start;
                    align-items:center;
                    height:55px;
                    width:100%;

                    img{
                        height:40px;
                        width:40px;
                        border-radius:5px;
                    }
                    span{
                        margin-left:5px;
                        font-size:11px;
                    }
                }

                .ProdutoInfo--pricearea{
                    display:flex;
                    align-items:center;
                    margin-bottom:5px;

                    
                    .ProdutoInfo--price {
                        display:flex;
                        align-items:center;

                        .ProdutoInfo--btnremover{
                            display:flex;
                            align-items:center;
                            cursor:pointer;
                
                            img{
                                height:20px;
                                width:20px;
                                margin-right:5px;
                            }
                        }
                    }
                    .ProdutoInfo--actualPrice {
                        font-size:14px;
                        margin-left:30px;
                    }
                    .ProdutoInfo--qtarea {
                        display:inline-flex;
                        background-color:#EEE;
                        border-radius:10px;
                        height:30px;
                    }
                    .ProdutoInfo--qtarea button {
                        border:0;
                        background-color:transparent;
                        font-size:17px;
                        outline:0;
                        cursor:pointer;
                        padding:0px 10px;
                        color:#333;
                    }
                    .ProdutoInfo--qt {
                        line-height: 30px;
                        font-size: 12px;
                        font-weight: bold;
                        padding: 0px 5px;
                        color:#000;
                    }
                    .ProdutoInfo--addButton {
                        margin-top:30px;
                        padding:20px 30px;
                        border-radius:20px;
                        background-color:#48d05f;
                        color:#FFF;
                        display:inline-block;
                        cursor:pointer;
                        margin-right:30px;
                    }
                    .ProdutoInfo--addButton:hover {
                        background-color:#32a345;
                    }
                    .ProdutoInfo--cancelButton {
                        display:inline-block;
                        cursor:pointer;
                    }
                    .ProdutoInfo--cancelMobileButton {
                        display:none;
                        height:40px;
                        text-align:center;
                        line-height: 40px;
                        margin-bottom:30px;
                    }
                }
            }
        }
        .cart--details{
            display:flex;
            flex-direction:column;

            .cart--totalitem {
                padding:15px 0;
                border-top:1px solid #79b9dd;
                color:#315970;
                display:flex;
                justify-content: space-between;
                font-size:15px;
            }
            .cart--totalitem span:first-child {
                font-weight: bold;
            }
            .cart--totalitem.big {
                font-size:20px;
                color:#000;
                font-weight: bold;
            }
            .cart--finalizar {
                padding:20px 30px;
                border-radius:20px;
                background-color:#48d05f;
                color:#FFF;
                cursor:pointer;
                text-align:center;
                margin-top:20px;
                border:2px solid #63f77c;
                transition: all ease .2s;
            }
            .cart--finalizar:hover {
                background-color:#35af4a;
            }

        }
    }
}
.show {
    width:30%;
    height:100%;
    border:1px solid #EEE;   
}

.AreaList{
    display:flex;
    flex:1;
    flex-direction:column;

    .productsTitle{
        width:100%;
        margin:24px 0 20px;
        text-align:center;

        .sectionTag{
            display:inline-flex;
            align-items:center;
            gap:8px;
            color:var(--salato-red);
            font-size:12px;
            font-weight:800;
            letter-spacing:.14em;
            text-transform:uppercase;

            &::before{
                content:'';
                width:18px;
                height:3px;
                border-radius:3px;
                background:var(--salato-yellow);
            }
        }

        h2{
            margin:10px 0 0;
            font-size:clamp(30px, 4vw, 48px);
            line-height:1.08;
            letter-spacing:-0.03em;
            color:var(--salato-ink);
            font-weight:800;
        }

        p{
            margin:12px auto 0;
            max-width:520px;
            color:var(--salato-muted);
            font-size:17px;
        }
    }

    .areaSubtitle{
        margin:0 10px 18px;
        color:#666;
        font-size:15px;
    }

    .mockSections{
        display:flex;
        flex-direction:column;
        gap:24px;
        margin:0 10px 10px;
    }

    .sectionTabs{
        position:sticky;
        top:calc(var(--header-h) + 8px);
        z-index:5;
        align-self:center;
        display:flex;
        flex-wrap:wrap;
        justify-content:center;
        gap:6px;
        padding:6px;
        border-radius:999px;
        background:rgba(255,255,255,.9);
        backdrop-filter:blur(8px);
        box-shadow:0 0 0 1px var(--salato-line), var(--shadow-md);
    }

    .tabButton{
        height:42px;
        padding:0 20px;
        border:0;
        border-radius:999px;
        background:transparent;
        color:var(--salato-muted);
        font-size:15px;
        font-weight:700;
        cursor:pointer;
        transition:background-color .25s var(--ease-out), color .2s ease, box-shadow .25s ease;

        &:hover{
            color:var(--salato-red);
            background:var(--salato-red-soft);
        }

        &.active{
            background:var(--salato-red);
            color:#fff;
            box-shadow:0 8px 18px rgba(236, 28, 36, .28);
        }
    }

    .sectionBlock{
        animation:sectionIn .45s var(--ease-out) both;
    }

    @keyframes sectionIn{
        from{ opacity:0; transform:translate3d(0, 14px, 0); }
        to{ opacity:1; transform:none; }
    }

    .sectionHeader{
        display:flex;
        align-items:baseline;
        justify-content:space-between;
        flex-wrap:wrap;
        gap:6px 16px;
        margin-bottom:18px;

        h3{
            margin:0;
            font-size:26px;
            color:var(--salato-ink);
            font-weight:800;
        }

        span{
            color:var(--salato-muted);
            font-size:15px;
        }
    }

    .sectionGrid{
        display:grid;
        grid-template-columns:repeat(4, minmax(0, 1fr));
        gap:20px;
    }

    .sectionCard{
        background:#fff;
        border-radius:22px;
        overflow:hidden;
        box-shadow:0 0 0 1px var(--salato-line), var(--shadow-sm);
        transition:transform .35s var(--ease-out), box-shadow .35s ease;
        animation:sectionIn .45s var(--ease-out) both;

        &:nth-child(2){ animation-delay:.04s; }
        &:nth-child(3){ animation-delay:.08s; }
        &:nth-child(4){ animation-delay:.12s; }
        &:nth-child(5){ animation-delay:.16s; }
        &:nth-child(6){ animation-delay:.2s; }
        &:nth-child(n+7){ animation-delay:.24s; }

        &:hover{
            transform:translateY(-6px);
            box-shadow:var(--shadow-lg);

            img{ transform:scale(1.07); }
        }
    }

    .sectionCardImage{
        aspect-ratio:4 / 3;
        overflow:hidden;
        background:#f6efe9;

        img{
            width:100%;
            height:100%;
            object-fit:cover;
            display:block;
            transition:transform .6s var(--ease-out), opacity .5s ease;
        }
    }

    .sectionCardInfo{
        padding:14px 16px 16px;

        strong{
            color:var(--salato-ink);
            font-size:15px;
            line-height:1.4;
            font-weight:700;
        }
    }

    .sectionEmpty{
        grid-column:1 / -1;
        min-height:120px;
        display:flex;
        align-items:center;
        justify-content:center;
        border:1px dashed #ffb3af;
        border-radius:16px;
        color:#888;
        background:#fff8f7;
        font-size:15px;
    }
    
    
    .AreaLoading{
        display:flex;
        position:absolute;
        width:100%;
        height:100%;
        justify-content:center;
        align-items:center;
    }
    .list{ 
        display:flex;
        justify-content:center;
        align-items:center;
        width:100%;
        flex-wrap:wrap;
        border-radius:5px;
        margin-bottom:10px;
        
        .adItem {
            width:25%;
        }
    }
    
    .pagination{
        display:flex;
        flex-wrap:wrap;
        justify-content:flex-end;
        align-items:flex-end;
        flex:1;
        margin:15px 0;
        padding-right:50px;

        .pagItem{
            display:flex;
            justify-content:center;
            align-items:center;
            height:30px;
            width:30px;
            border:1px solid #FF0000;
            margin:1px;
            cursor:pointer;

        }
        .active{
            background-color:#CCC;
        }
    }
}


@media (max-width:800px){
    aside{

        .cart--area {
            .menu-closer1{
                display:none;
            }

            .menu-closer2{
                display:flex;
            }
        }
        .cart .cart--itens .ProdutoInfo--pricearea .ProdutoInfo--price{
            justify-content:space-between;  
            width:100%;
        }
    }

    .show {
        display:flex;
        position:fixed;
        flex-direction:column;
        top:0;
        right:0;
        
        bottom:0;
        width:100%;
        border-radius:10px;
        border:1px solid #FFFFFF;   
        background-color:#ffffff;
    }
    
    .AreaList{

        .sectionGrid{
            grid-template-columns:repeat(2, minmax(0, 1fr));
        }

        .list{

            .adItem{
                width:33%;
            }
        }
    }
}

@media (max-width:600px){
    .AreaList{

        .sectionBlock{
            padding:0;
        }

        .sectionHeader h3{
            font-size:24px;
        }

        .sectionTabs{
            gap:10px;
        }

        .sectionTabs{
            border-radius:18px;
        }

        .tabButton{
            flex:1 1 auto;
            padding:0 14px;
            font-size:14px;
        }

        .sectionGrid{
            grid-template-columns:repeat(2, minmax(0, 1fr));
            gap:12px;
        }

        .sectionCardInfo{
            padding:10px 12px 12px;

            strong{ font-size:13px; }
        }

        .list{

            .adItem{
                width:50%;
            }
        }
    }
}
`;